import { useEffect } from 'react';
import nimInst from 'services/nim';
import { useQueryClient } from '@tanstack/react-query';

export const useLightWeight = () => {
  const queryClient = useQueryClient();
  useEffect(() => {
    return nimInst.on('sys:message:sync_order_balance', () => {
      queryClient.invalidateQueries(['lightWeightPackageInfo']);
    });
  }, [queryClient]);
};
